import { render, staticRenderFns } from "./Indicador.vue?vue&type=template&id=2772ef7c&scoped=true"
import script from "./Indicador.vue?vue&type=script&lang=js"
export * from "./Indicador.vue?vue&type=script&lang=js"
import style0 from "./Indicador.vue?vue&type=style&index=0&id=2772ef7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772ef7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
